import { IAdherent } from './adherent.model';
import { Moment } from 'moment';
import { CompositionTypeEnum } from '../constant/enum'

export interface IProjetAnneeAdherentStaff {
  id?: number;
  adherent?: IAdherent;
  roleStaff?: string;
  validationStagePratiqueBafa?: boolean;
  validationStagePratiqueBafd?: boolean;
  isDirecteAttachment?: boolean;
  compositionType?: CompositionTypeEnum;
}

export class ProjetAnneeAdherentStaff {
  constructor(
    public id?: number,
    public adherent?: IAdherent,
    public roleStaff?: string,
    public validationStagePratiqueBafa?: boolean,
    public validationStagePratiqueBafd?: boolean,
    public isDirecteAttachment?: boolean,
    public compositionType?: CompositionTypeEnum
  ) { }
}
